import { BaseEntity } from "@common/ADAPT.Common.Model/base-entity";
import { BreezeModelBuilder } from "@common/ADAPT.Common.Model/breeze-model-builder";
import { Organisation } from "@common/ADAPT.Common.Model/organisation/organisation";
import { Person } from "@common/ADAPT.Common.Model/person/person";

export class CulturalExclusion extends BaseEntity<CulturalExclusion> {
    public culturalExclusionId!: number;
    public organisationId!: number;
    public personId!: number;
    public organisation!: Organisation;
    public person!: Person;
}

export const CulturalExclusionBreezeModel = new BreezeModelBuilder("CulturalExclusion", CulturalExclusion)
    .hasSource()
    .withIdField()
    .isOrganisationEntity()
    .alwaysFetchingNavigationProperty("person")
    .withActivePath("person.connections")
    .build();
